import type { FC, ReactElement } from 'react';

import { LiveSupportControlPlain } from '@pp/core/src/components/nav/navControls/liveSupportControl/LiveSupportControlPlain';
import { Logger } from '@pp/core/src/logger/Logger';
import { useActiveDialogCleaner, useDrawerHidden } from '@pp/core/src/store/actions/useActiveDialogCleaner';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useChatSlice } from '@pp/core/src/store/slices/chat/selectors';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { headerActions } from '@pp/core/src/store/slices/header/slice';
import { HeaderModal } from '@pp/core/src/store/slices/header/types';

import { highflyerGameStateActions } from '../../store/slices/highflyerGame/slice';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';

export const LiveSupportControlConnected: FC = (): ReactElement | null => {
  const dispatch = useCoreDispatch();
  const isChatDisabled = useConfigSlice.isChatDisabled();

  const isLiveSupportRead = useChatSlice.getIsLiveSupportRead();
  const isSupportTabSelected = useHighflyerGameStateSlice.getSelectedHeader() == HeaderModal.Support; 

  const drawerHidden = useDrawerHidden();
  const cleanDialogs = useActiveDialogCleaner();

  if (isChatDisabled) {
    return null;
  }

  return (
    <LiveSupportControlPlain
      condition={isSupportTabSelected}
      onClick={(): void => {
        // UIC-64 | Hide Dialogs Functionality
        drawerHidden && cleanDialogs();
        if (drawerHidden || !isSupportTabSelected) {
          dispatch(highflyerGameStateActions.setChatClosed(false));
          dispatch(highflyerGameStateActions.setSelectedHeader(HeaderModal.Support));

          dispatch(headerActions.setOpenedModal(HeaderModal.Support));
          Logger.logEvent('click', 'chatModalOpen', Date.now(), 1, 'support', false);
        } else {
          dispatch(highflyerGameStateActions.setSelectedHeader(null));
          dispatch(highflyerGameStateActions.setChatClosed(true));
          dispatch(headerActions.setOpenedModal(null));
        }
      }}
      showBadge={!isLiveSupportRead}
    />
  );
};
